<template>
    <div style="height: 100%;width: 100%">
        <Breadcrumb></Breadcrumb>
        <div class="form-body">
            <el-form ref="form" :model="queryParams" :inline="true">
                <el-row style="margin: 10px 0px">
                    <el-form-item label="提现状态: " >
                        <el-select clearable  size="small" style="width: 200px" v-model="queryParams.status"  placeholder="请选择">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row style="margin: 10px 0px">
                    <el-form-item label="提现时间: " >
                        <el-date-picker style="width: 200px"
                                        v-model="queryParams.kssj"
                                        type="datetime" size="small"
                                        placeholder="选择日期时间">
                        </el-date-picker>
                        <span class="demonstration">~</span>
                        <el-date-picker style="width: 200px"
                                        v-model="queryParams.jssj"
                                        type="datetime" size="small"
                                        placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                </el-row>
                <el-row style="margin: 10px 0px">
                    <el-form-item label="商家账号: ">
                        <el-input size="small" style="width: 279px" v-model="queryParams.p_ope_no" class="in" placeholder="请输入商家账号" ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" plain @click="reset" size="small">重置</el-button>
                        <el-button type="primary" @click="queryData" size="small">搜索</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div class="el-main-border withdrawalCheck">
            <!-- 表格 -->
            <div>
                <el-table v-loading="loading" :data="tableData" highlight-current-row @current-change="handleCurrentChange"
                          heighighlight-current-rowht="250" borderstyle="width: 100%"
                          :header-cell-style="{background:'#eef1f6',color:'#595a5a'}" border>
                    <el-table-column type="index" width="50" align="center"></el-table-column>
                    <el-table-column prop="p_ope_no" label="商家账号"  align="center"></el-table-column>
                    <el-table-column prop="create_time" label="提现时间"  align="center" width="200"></el-table-column>
                    <el-table-column prop="amount" label="提现金额"  align="center" :formatter="formatter"></el-table-column>
                    <el-table-column prop="nick_name" label="姓名" width="150"  align="center"></el-table-column>
                    <el-table-column prop="alipay_account" label="支付宝账号" width="150"  align="center"></el-table-column>
                    <el-table-column prop="status" label="提现状态" width="115" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == '01'">待审核<i class="iconfont" style="color: #ffb100;">&#xe607;</i></span>
                            <span v-else-if="scope.row.status == '02'">审核通过<i class="el-icon-circle-check" style="color: #409eff;"></i></span>
                            <span v-else>审核不通过<i class="el-icon-circle-close" style="color: red;"></i></span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="auditor" label="审核人"  align="center">
                    </el-table-column>
                    <el-table-column prop="audit_time" label="审核时间"  align="center" width="200">
                    </el-table-column>
                    <el-table-column prop="audit_opinio" label="审核意见"  align="center" width="250">
                    </el-table-column>
                    <el-table-column label="审核" fixed="right">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status == '01'" type="danger"  @click="txsh(scope.$index, scope.row)" size="small">审核</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination
                        v-show="total>0"
                        :total="total"
                        :page.sync="queryParams.pageNum"
                        :limit.sync="queryParams.pageSize"
                        @pagination="queryData"
                />
            </div>
            <!--提现审核-->
            <el-dialog :close-on-click-modal="false"   class="ware-dialog" :title="title" :visible.sync="wareFormVisible" :destroy-on-close=true width="36rem">
                <el-form :model="wareForm" :rules="rules" ref="wareForm" style="margin: 10px;padding: 0 15px" label-width="100px">
                    <el-form-item prop="wareId" style="display: none">
                        <el-input v-model="wareForm.withdraw_id"></el-input>
                    </el-form-item>

                    <el-form-item label="商家账户信息: " prop="" style="font-weight: bold;"></el-form-item>
                    <!--<div class="ord-div-inputel">-->
                    <div style="border: 1px solid #dcdcdc;border-radius: 5px;margin-bottom: 11px;">
                        <el-form-item label="商家账号: " prop="p_ope_no">
                            <span size="small" v-model="wareForm.p_ope_no" style="width: 200px;">{{wareForm.p_ope_no}}</span>
                        </el-form-item>
                        <el-form-item label="当前账户余额: " prop="balance">
                            <span size="small" v-model="wareForm.balance" style="width: 200px;color: red;">{{wareForm.balance}}</span><span>元</span>
                        </el-form-item>
                        <el-form-item label="姓名: " prop="nice_name" >
                            <span size="small" v-model="wareForm.nick_name" style="width: 200px;">{{ wareForm.nick_name }}</span>
                        </el-form-item>
                        <el-form-item label="支付宝账号: " prop="alipay_account">
                            <span size="small" v-model="wareForm.alipay_account" style="width: 200px;">{{wareForm.alipay_account}}</span>
                        </el-form-item>
                        <el-form-item label="提现金额: " prop="amount" >
                            <span size="small" v-model="wareForm.amount" style="width: 200px;">{{wareForm.amount}}</span><span>元</span>
                        </el-form-item>

                    </div>


                    <el-form-item label="审核结果: " prop="status" class="elaa">
                        <el-radio v-model="wareForm.status" :disabled="(btnBoolean == btnStatus)== 1 ? true : false" label="02">通过</el-radio>
                        <el-radio v-model="wareForm.status" :disabled="(btnBoolean == btnStatus)== 1 ? true : false" label="03">不通过</el-radio>
                    </el-form-item>
                    <el-form-item label="审核意见: " prop="audit_opinio" class="elaa">
                        <el-input style="border-color: #dcdcdc"
                                type="textarea"
                                :rows="2"
                                :disabled="(btnBoolean == btnStatus)== 1 ? true : false"
                                placeholder=""
                                v-model="wareForm.audit_opinio">
                        </el-input>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="medium " @click="closeWareFormDialog">取 消</el-button>
                    <el-button size="medium " v-if="status==='01'" type="primary" @click="submitForm">保存</el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {listTx,getUserProfile,updateWithdraw,saveTx} from '@/api/business/moneyManger'
    export default {
        components:{Breadcrumb},
        data: function () {
            return {
                status:'01',
                audit_opinio:'',
                withdrawid:'',
                nickname:'',
                alipayaccount:'',
                amount:'',
                auditopinio:'',
                popeno:'',

                btnBoolean: Boolean,//data中设置布尔以及判断条件
                btnStatus: -1,
                shradio: '',//审核结果
                shyj:'',
                loading: false,
                total:0,
                form:{},
                tableData: [],
                options: [{
                    value: '',
                    label: '全部'
                },{
                    value: '01',
                    label: '待审核'
                }, {
                    value: '02',
                    label: '审核通过'
                }, {
                    value: '03',
                    label: '审核不通过'
                }],
                // const date = new Date();
                // date.setTime(date.getTime() - 3600 * 1000 * 24);
                queryParams:{
                    type:'1',
                    p_ope_no:'',
                    status:'',
                    kssj:new Date(new Date() - 3600 * 1000 * 24 * 7),
                    jssj:new Date(),
                    pageNum: 1,
                    pageSize: 30,
                },
                wareForm: {},
                //弹框变量
                title:null,
                wareFormVisible:false,
                //验证
                rules: {
                    shjg: {required: true, message: '审核结果不能为空'}
                },
            };
        },
        created() {
            this.queryData()
        },
        methods: {
            //重置表单
            reset(){
                this.queryParams.p_ope_no = ''
                this.queryParams.status = ''

            },
            //获取当前账号查询提现记录
            queryData(){
                var data = {}
                data.pageNum = this.queryParams.pageNum
                data.pageSize = this.queryParams.pageSize
                data.type = '1'
                data.status = this.queryParams.status
                data.p_ope_no = this.queryParams.p_ope_no
                if(this.queryParams.kssj){
                    let date = new Date(this.queryParams.kssj-0);
                    let y = date.getFullYear();
                    let MM = date.getMonth() + 1;
                    MM = MM < 10 ? ('0' + MM) : MM;
                    let d = date.getDate();
                    d = d < 10 ? ('0' + d) : d;
                    let h = date.getHours();
                    h = h < 10 ? ('0' + h) : h;
                    let m = date.getMinutes();
                    m = m < 10 ? ('0' + m) : m;
                    let s = date.getSeconds();
                    s = s < 10 ? ('0' + s) : s;
                    data.kssj = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s

                }

                if(this.queryParams.jssj){
                    let date1 = new Date(this.queryParams.jssj-0);
                    let y1 = date1.getFullYear();
                    let MM1 = date1.getMonth() + 1;
                    MM1 = MM1 < 10 ? ('0' + MM1) : MM1;
                    let d1 = date1.getDate();
                    d1 = d1 < 10 ? ('0' + d1) : d1;
                    let h1 = date1.getHours();
                    h1 = h1 < 10 ? ('0' + h1) : h1;
                    let m1 = date1.getMinutes();
                    m1 = m1 < 10 ? ('0' + m1) : m1;
                    let s1 = date1.getSeconds();
                    s1 = s1 < 10 ? ('0' + s1) : s1;

                    data.jssj = y1 + '-' + MM1 + '-' + d1 + ' ' + h1 + ':' + m1 + ':' + s1

                }

                listTx(data).then(res => {
                    if(res.code == 200){
                        this.total = res.total;
                        this.tableData = res.rows;
                    }
                    this.loading = false;
                }).catch(err =>{});
            },
            //提现审核弹窗
            txsh(index,row) {
                // if(!this.currentRow){
                //     this.$message('请选择一条审核申请！');
                //     return
                // }
                this.title = '提现审核';
                this.wareFormVisible = true;
                //查询用户账户余额
                // this.wareForm.type = '1';
                // this.wareForm.p_ope_no = row.p_ope_no
                var data = {type:'1',p_ope_no:row.p_ope_no}
                getUserProfile(data).then(response => {
                    this.wareForm = {}
                    this.wareForm.withdraw_id = row.withdraw_id;
                    this.wareForm.p_ope_no = row.p_ope_no
                    this.wareForm.nick_name = row.nick_name;
                    this.wareForm.alipay_account = row.alipay_account;
                    this.status = row.status;
                    this.audit_opinio = row.audit_opinio;
                    this.wareForm.amount = row.amount.toFixed(2);
                    this.wareForm.balance = response.data.balance.toFixed(2);

                    if(row.status=='01'){
                        this.btnBoolean = 1;
                    }else{
                        this.btnBoolean = -1;
                    }
                    // this.wareForm = this.currentRow
                    // this.wareForm.amount = this.wareForm.amount.toFixed(2);
                    // this.wareForm.balance = response.data.balance.toFixed(2);
                    //
                    // if(this.currentRow.status=='01'){
                    //     this.btnBoolean = 1;
                    // }else{
                    //     this.btnBoolean = -1;
                    // }
                });

            },
            //格式化提现金额
            formatter(row, column){
                return ( (row.amount + '').indexOf('.') != -1 ) ? row.amount: row.amount.toFixed(2);
            },
            //dia关闭前清空数据
            closeDia() {
                for (let key in this.wareForm) {
                    this.wareForm[key] = null;
                }
            },
            submitForm(){
                if(this.wareForm.status!='02'&&this.wareForm.status!='03'){
                    this.$message('请选择审核结果！');
                    return
                }
                if(this.wareForm.status=='03'&&!this.wareForm.audit_opinio){
                    this.$message('请输入审核意见！');
                    return
                }
                if(this.wareForm.status=='02'&&parseFloat(this.wareForm.balance)<parseFloat(this.wareForm.amount)){
                    this.$message('提现金额大于账户余额！');
                    return
                }

                updateWithdraw(this.wareForm).then(response => {
                        this.$message("操作成功");
                        setTimeout(() => {
                            this.wareFormVisible = false
                            this.queryData()
                        }, 2000);

                });
            },
            closeWareFormDialog(){
                this.wareFormVisible = false;
            },
            handleCurrentChange(val) {
                this.currentRow = val
                this.withdrawid = val.withdraw_id
                this.nickname = val.nick_name
                this.alipayaccount = val.alipay_account
                this.auditopinio = val.audit_opinio
                this.popeno = val.p_ope_no
                this.amount = val.amount
            }

        }
    }
</script>

<style>
    .in {
        width: 250px;
    }
    .head .el-dialog__header {
        background-color: #eef1f6;
    }

    .ware-dialog .el-form-item{margin-bottom: 11px !important;}
    .ware-dialog .el-form-item .el-form-item__error{padding-top: initial !important;}

    .withdrawalCheck .el-table .el-table__row td:nth-child(7) {
        text-align: right;
    }
    .withdrawalCheck .el-table .el-table__row td:nth-child(7) span {
        margin-right: 3px;
    }
    .withdrawalCheck .el-table .el-table__row td:nth-child(7) i {
        margin-left: 3px;
        font-size: 17px;
    }

    .withdrawalCheck .el-table--fit {
        border-right: 0 !important;
        border-left: 0 !important;
        border-bottom: 0 !important;
        margin-bottom: 3px;
    }
    .withdrawalCheck .el-table--border td {
        border-right: 0 solid !important;
    }

    .ware-dialog .el-form div:nth-child(2) {
        margin-bottom: 0 !important;
    }
    .ware-dialog .el-form div:nth-child(3) .el-form-item {
        margin-bottom: 0 !important;
        padding: 0 15px;
    }
    .ware-dialog .el-form .elaa {
        margin-left: -27px;
    }
    .ware-dialog .el-form .elaa .el-form-item__label {
        font-weight: bold;
    }


</style>
